import { BaseObj } from '@/objects/BaseObj';
import { useBaseObjEntityStateHandler } from '@/objects/entitystatehandler/entitystatehandler';
import { isRef, ref, unref } from 'vue';
import type { EntityState } from './../enums/EntityState';

export class FISDataEvent extends BaseObj {
    public ID: number;
    public __id: number;

    public Clockahomologisering: string | null;
    public __clockahomologisering: string | null;

    public Clockamerke: string | null;
    public __clockamerke: string | null;

    public Clockamodel: string | null;
    public __clockamodel: string | null;

    public Clockaserienr: string | null;
    public __clockaserienr: string | null;

    public Clockbhomologisering: string | null;
    public __clockbhomologisering: string | null;

    public Clockbmerke: string | null;
    public __clockbmerke: string | null;

    public Clockbmodel: string | null;
    public __clockbmodel: string | null;

    public Clockbserienr: string | null;
    public __clockbserienr: string | null;

    public Clockmanualmerke: string | null;
    public __clockmanualmerke: string | null;

    public Clockmanualmodel: string | null;
    public __clockmanualmodel: string | null;

    public Clockmanualserienr: string | null;
    public __clockmanualserienr: string | null;

    public Doctor: string | null;
    public __doctor: string | null;

    public EventID: number;
    public __eventid: number;

    public Fotocelleahomologisering: string | null;
    public __fotocelleahomologisering: string | null;

    public Fotocelleamerke: string | null;
    public __fotocelleamerke: string | null;

    public Fotocelleamodel: string | null;
    public __fotocelleamodel: string | null;

    public Fotocelleaserienr: string | null;
    public __fotocelleaserienr: string | null;

    public Fotocellebhomologisering: string | null;
    public __fotocellebhomologisering: string | null;

    public Fotocellebmerke: string | null;
    public __fotocellebmerke: string | null;

    public Fotocellebmodel: string | null;
    public __fotocellebmodel: string | null;

    public Fotocellebserienr: string | null;
    public __fotocellebserienr: string | null;

    public Insurance: string | null;
    public __insurance: string | null;

    public Jurycoc: string | null;
    public __jurycoc: string | null;

    public Juryjudge2: string | null;
    public __juryjudge2: string | null;

    public Juryjudge3: string | null;
    public __juryjudge3: string | null;

    public Jurynationaltd: string | null;
    public __jurynationaltd: string | null;

    public Juryracedir: string | null;
    public __juryracedir: string | null;

    public Jurytdass: string | null;
    public __jurytdass: string | null;

    public Lagledermote: string | null;
    public __lagledermote: string | null;

    public Loypesjef: string | null;
    public __loypesjef: string | null;

    public Malkamerahomologisering: string | null;
    public __malkamerahomologisering: string | null;

    public Malkameramerke: string | null;
    public __malkameramerke: string | null;

    public Malkameramodel: string | null;
    public __malkameramodel: string | null;

    public Malkameraserienr: string | null;
    public __malkameraserienr: string | null;

    public Policenumber: string | null;
    public __policenumber: string | null;

    public Rennkomentar: string | null;
    public __rennkomentar: string | null;

    public Snowcondition: string | null;
    public __snowcondition: string | null;

    public Startclocklockhomologisering: string | null;
    public __startclocklockhomologisering: string | null;

    public Startclocklockmerke: string | null;
    public __startclocklockmerke: string | null;

    public Startclocklockmodel: string | null;
    public __startclocklockmodel: string | null;

    public Startclocklockserienr: string | null;
    public __startclocklockserienr: string | null;

    public Startgrindhomologisering: string | null;
    public __startgrindhomologisering: string | null;

    public Startgrindmerke: string | null;
    public __startgrindmerke: string | null;

    public Startgrindmodel: string | null;
    public __startgrindmodel: string | null;

    public Startgrindserienr: string | null;
    public __startgrindserienr: string | null;

    public Startgrindtype: number | null;
    public __startgrindtype: number | null;

    public Startpistolhomologisering: string | null;
    public __startpistolhomologisering: string | null;

    public Startpistolmerke: string | null;
    public __startpistolmerke: string | null;

    public Startpistolmodel: string | null;
    public __startpistolmodel: string | null;

    public Startpistolserienr: string | null;
    public __startpistolserienr: string | null;

    public Startpistoltype: number | null;
    public __startpistoltype: number | null;

    public Synca: string | null;
    public __synca: string | null;

    public Syncb: string | null;
    public __syncb: string | null;

    public Syncbstart: string | null;
    public __syncbstart: string | null;

    public Synchand: string | null;
    public __synchand: string | null;

    public Syncsync: string | null;
    public __syncsync: string | null;

    public Tdaddress: string | null;
    public __tdaddress: string | null;

    public Tdemail: string | null;
    public __tdemail: string | null;

    public Tdname: string | null;
    public __tdname: string | null;

    public Tdnation: string | null;
    public __tdnation: string | null;

    public Tdphone: string | null;
    public __tdphone: string | null;

    public Teknisk: string | null;
    public __teknisk: string | null;

    public Tempair: string | null;
    public __tempair: string | null;

    public Tempsnow: string | null;
    public __tempsnow: string | null;

    public Timerclub: string | null;
    public __timerclub: string | null;

    public Timeremail: string | null;
    public __timeremail: string | null;

    public Timerfirstname: string | null;
    public __timerfirstname: string | null;

    public Timernation: string | null;
    public __timernation: string | null;

    public Timerphone: string | null;
    public __timerphone: string | null;

    public Timersurname: string | null;
    public __timersurname: string | null;

    public Weather: string | null;
    public __weather: string | null;

    public __entityStateHandler;
    public __selfEntityState: EntityState;
    public __entityState: any;
    public get EntityState(): EntityState {
        return unref(this.__entityState);
    }
    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        Clockahomologisering?: string | null;
        Clockamerke?: string | null;
        Clockamodel?: string | null;
        Clockaserienr?: string | null;
        Clockbhomologisering?: string | null;
        Clockbmerke?: string | null;
        Clockbmodel?: string | null;
        Clockbserienr?: string | null;
        Clockmanualmerke?: string | null;
        Clockmanualmodel?: string | null;
        Clockmanualserienr?: string | null;
        Doctor?: string | null;
        EntityState?: EntityState;
        EventID?: number;
        Fotocelleahomologisering?: string | null;
        Fotocelleamerke?: string | null;
        Fotocelleamodel?: string | null;
        Fotocelleaserienr?: string | null;
        Fotocellebhomologisering?: string | null;
        Fotocellebmerke?: string | null;
        Fotocellebmodel?: string | null;
        Fotocellebserienr?: string | null;
        Insurance?: string | null;
        Jurycoc?: string | null;
        Juryjudge2?: string | null;
        Juryjudge3?: string | null;
        Jurynationaltd?: string | null;
        Juryracedir?: string | null;
        Jurytdass?: string | null;
        Lagledermote?: string | null;
        Loypesjef?: string | null;
        Malkamerahomologisering?: string | null;
        Malkameramerke?: string | null;
        Malkameramodel?: string | null;
        Malkameraserienr?: string | null;
        Policenumber?: string | null;
        Rennkomentar?: string | null;
        Snowcondition?: string | null;
        Startclocklockhomologisering?: string | null;
        Startclocklockmerke?: string | null;
        Startclocklockmodel?: string | null;
        Startclocklockserienr?: string | null;
        Startgrindhomologisering?: string | null;
        Startgrindmerke?: string | null;
        Startgrindmodel?: string | null;
        Startgrindserienr?: string | null;
        Startgrindtype?: number | null;
        Startpistolhomologisering?: string | null;
        Startpistolmerke?: string | null;
        Startpistolmodel?: string | null;
        Startpistolserienr?: string | null;
        Startpistoltype?: number | null;
        Synca?: string | null;
        Syncb?: string | null;
        Syncbstart?: string | null;
        Synchand?: string | null;
        Syncsync?: string | null;
        Tdaddress?: string | null;
        Tdemail?: string | null;
        Tdname?: string | null;
        Tdnation?: string | null;
        Tdphone?: string | null;
        Teknisk?: string | null;
        Tempair?: string | null;
        Tempsnow?: string | null;
        Timerclub?: string | null;
        Timeremail?: string | null;
        Timerfirstname?: string | null;
        Timernation?: string | null;
        Timerphone?: string | null;
        Timersurname?: string | null;
        Weather?: string | null;
    }) {
        super();
        this.__entityState = ref(values.EntityState ?? 'Unchanged');
        this.__selfEntityState = values.EntityState ?? 'Unchanged';
        this.__entityStateHandler = useBaseObjEntityStateHandler<FISDataEvent>(unref(this.__entityState), (states) => {
            if (isRef(this.__entityState)) {
                this.__entityState.value = states.EntityStateWithChildrenConsidered;
            } else {
                console.warn('FISDataEvent tried to set entitystate, but entitystate is not a ref! This should never happen');
            }
            this.__selfEntityState = states.SelfEntityState;
        });
        this.ID = values.ID ?? 0;
        this.__id = values.ID ?? 0;
        Object.defineProperty(this, 'ID', {
            get(): number {
                return this.__id;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockahomologisering = values.Clockahomologisering ?? null;
        this.__clockahomologisering = values.Clockahomologisering ?? null;
        Object.defineProperty(this, 'Clockahomologisering', {
            get(): string | null {
                return this.__clockahomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockahomologisering', this.__clockahomologisering, value);
                this.__clockahomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockamerke = values.Clockamerke ?? null;
        this.__clockamerke = values.Clockamerke ?? null;
        Object.defineProperty(this, 'Clockamerke', {
            get(): string | null {
                return this.__clockamerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockamerke', this.__clockamerke, value);
                this.__clockamerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockamodel = values.Clockamodel ?? null;
        this.__clockamodel = values.Clockamodel ?? null;
        Object.defineProperty(this, 'Clockamodel', {
            get(): string | null {
                return this.__clockamodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockamodel', this.__clockamodel, value);
                this.__clockamodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockaserienr = values.Clockaserienr ?? null;
        this.__clockaserienr = values.Clockaserienr ?? null;
        Object.defineProperty(this, 'Clockaserienr', {
            get(): string | null {
                return this.__clockaserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockaserienr', this.__clockaserienr, value);
                this.__clockaserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockbhomologisering = values.Clockbhomologisering ?? null;
        this.__clockbhomologisering = values.Clockbhomologisering ?? null;
        Object.defineProperty(this, 'Clockbhomologisering', {
            get(): string | null {
                return this.__clockbhomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockbhomologisering', this.__clockbhomologisering, value);
                this.__clockbhomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockbmerke = values.Clockbmerke ?? null;
        this.__clockbmerke = values.Clockbmerke ?? null;
        Object.defineProperty(this, 'Clockbmerke', {
            get(): string | null {
                return this.__clockbmerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockbmerke', this.__clockbmerke, value);
                this.__clockbmerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockbmodel = values.Clockbmodel ?? null;
        this.__clockbmodel = values.Clockbmodel ?? null;
        Object.defineProperty(this, 'Clockbmodel', {
            get(): string | null {
                return this.__clockbmodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockbmodel', this.__clockbmodel, value);
                this.__clockbmodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockbserienr = values.Clockbserienr ?? null;
        this.__clockbserienr = values.Clockbserienr ?? null;
        Object.defineProperty(this, 'Clockbserienr', {
            get(): string | null {
                return this.__clockbserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockbserienr', this.__clockbserienr, value);
                this.__clockbserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockmanualmerke = values.Clockmanualmerke ?? null;
        this.__clockmanualmerke = values.Clockmanualmerke ?? null;
        Object.defineProperty(this, 'Clockmanualmerke', {
            get(): string | null {
                return this.__clockmanualmerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockmanualmerke', this.__clockmanualmerke, value);
                this.__clockmanualmerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockmanualmodel = values.Clockmanualmodel ?? null;
        this.__clockmanualmodel = values.Clockmanualmodel ?? null;
        Object.defineProperty(this, 'Clockmanualmodel', {
            get(): string | null {
                return this.__clockmanualmodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockmanualmodel', this.__clockmanualmodel, value);
                this.__clockmanualmodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Clockmanualserienr = values.Clockmanualserienr ?? null;
        this.__clockmanualserienr = values.Clockmanualserienr ?? null;
        Object.defineProperty(this, 'Clockmanualserienr', {
            get(): string | null {
                return this.__clockmanualserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Clockmanualserienr', this.__clockmanualserienr, value);
                this.__clockmanualserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Doctor = values.Doctor ?? null;
        this.__doctor = values.Doctor ?? null;
        Object.defineProperty(this, 'Doctor', {
            get(): string | null {
                return this.__doctor;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Doctor', this.__doctor, value);
                this.__doctor = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.EventID = values.EventID ?? 0;
        this.__eventid = values.EventID ?? 0;
        Object.defineProperty(this, 'EventID', {
            get(): number {
                return this.__eventid;
            },
            set(value: number) {
                this.__entityStateHandler.propertyChanged('EventID', this.__eventid, value);
                this.__eventid = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocelleahomologisering = values.Fotocelleahomologisering ?? null;
        this.__fotocelleahomologisering = values.Fotocelleahomologisering ?? null;
        Object.defineProperty(this, 'Fotocelleahomologisering', {
            get(): string | null {
                return this.__fotocelleahomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocelleahomologisering', this.__fotocelleahomologisering, value);
                this.__fotocelleahomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocelleamerke = values.Fotocelleamerke ?? null;
        this.__fotocelleamerke = values.Fotocelleamerke ?? null;
        Object.defineProperty(this, 'Fotocelleamerke', {
            get(): string | null {
                return this.__fotocelleamerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocelleamerke', this.__fotocelleamerke, value);
                this.__fotocelleamerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocelleamodel = values.Fotocelleamodel ?? null;
        this.__fotocelleamodel = values.Fotocelleamodel ?? null;
        Object.defineProperty(this, 'Fotocelleamodel', {
            get(): string | null {
                return this.__fotocelleamodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocelleamodel', this.__fotocelleamodel, value);
                this.__fotocelleamodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocelleaserienr = values.Fotocelleaserienr ?? null;
        this.__fotocelleaserienr = values.Fotocelleaserienr ?? null;
        Object.defineProperty(this, 'Fotocelleaserienr', {
            get(): string | null {
                return this.__fotocelleaserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocelleaserienr', this.__fotocelleaserienr, value);
                this.__fotocelleaserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocellebhomologisering = values.Fotocellebhomologisering ?? null;
        this.__fotocellebhomologisering = values.Fotocellebhomologisering ?? null;
        Object.defineProperty(this, 'Fotocellebhomologisering', {
            get(): string | null {
                return this.__fotocellebhomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocellebhomologisering', this.__fotocellebhomologisering, value);
                this.__fotocellebhomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocellebmerke = values.Fotocellebmerke ?? null;
        this.__fotocellebmerke = values.Fotocellebmerke ?? null;
        Object.defineProperty(this, 'Fotocellebmerke', {
            get(): string | null {
                return this.__fotocellebmerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocellebmerke', this.__fotocellebmerke, value);
                this.__fotocellebmerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocellebmodel = values.Fotocellebmodel ?? null;
        this.__fotocellebmodel = values.Fotocellebmodel ?? null;
        Object.defineProperty(this, 'Fotocellebmodel', {
            get(): string | null {
                return this.__fotocellebmodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocellebmodel', this.__fotocellebmodel, value);
                this.__fotocellebmodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fotocellebserienr = values.Fotocellebserienr ?? null;
        this.__fotocellebserienr = values.Fotocellebserienr ?? null;
        Object.defineProperty(this, 'Fotocellebserienr', {
            get(): string | null {
                return this.__fotocellebserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fotocellebserienr', this.__fotocellebserienr, value);
                this.__fotocellebserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Insurance = values.Insurance ?? null;
        this.__insurance = values.Insurance ?? null;
        Object.defineProperty(this, 'Insurance', {
            get(): string | null {
                return this.__insurance;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Insurance', this.__insurance, value);
                this.__insurance = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Jurycoc = values.Jurycoc ?? null;
        this.__jurycoc = values.Jurycoc ?? null;
        Object.defineProperty(this, 'Jurycoc', {
            get(): string | null {
                return this.__jurycoc;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Jurycoc', this.__jurycoc, value);
                this.__jurycoc = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Juryjudge2 = values.Juryjudge2 ?? null;
        this.__juryjudge2 = values.Juryjudge2 ?? null;
        Object.defineProperty(this, 'Juryjudge2', {
            get(): string | null {
                return this.__juryjudge2;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Juryjudge2', this.__juryjudge2, value);
                this.__juryjudge2 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Juryjudge3 = values.Juryjudge3 ?? null;
        this.__juryjudge3 = values.Juryjudge3 ?? null;
        Object.defineProperty(this, 'Juryjudge3', {
            get(): string | null {
                return this.__juryjudge3;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Juryjudge3', this.__juryjudge3, value);
                this.__juryjudge3 = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Jurynationaltd = values.Jurynationaltd ?? null;
        this.__jurynationaltd = values.Jurynationaltd ?? null;
        Object.defineProperty(this, 'Jurynationaltd', {
            get(): string | null {
                return this.__jurynationaltd;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Jurynationaltd', this.__jurynationaltd, value);
                this.__jurynationaltd = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Juryracedir = values.Juryracedir ?? null;
        this.__juryracedir = values.Juryracedir ?? null;
        Object.defineProperty(this, 'Juryracedir', {
            get(): string | null {
                return this.__juryracedir;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Juryracedir', this.__juryracedir, value);
                this.__juryracedir = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Jurytdass = values.Jurytdass ?? null;
        this.__jurytdass = values.Jurytdass ?? null;
        Object.defineProperty(this, 'Jurytdass', {
            get(): string | null {
                return this.__jurytdass;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Jurytdass', this.__jurytdass, value);
                this.__jurytdass = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Lagledermote = values.Lagledermote ?? null;
        this.__lagledermote = values.Lagledermote ?? null;
        Object.defineProperty(this, 'Lagledermote', {
            get(): string | null {
                return this.__lagledermote;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Lagledermote', this.__lagledermote, value);
                this.__lagledermote = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Loypesjef = values.Loypesjef ?? null;
        this.__loypesjef = values.Loypesjef ?? null;
        Object.defineProperty(this, 'Loypesjef', {
            get(): string | null {
                return this.__loypesjef;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Loypesjef', this.__loypesjef, value);
                this.__loypesjef = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Malkamerahomologisering = values.Malkamerahomologisering ?? null;
        this.__malkamerahomologisering = values.Malkamerahomologisering ?? null;
        Object.defineProperty(this, 'Malkamerahomologisering', {
            get(): string | null {
                return this.__malkamerahomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Malkamerahomologisering', this.__malkamerahomologisering, value);
                this.__malkamerahomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Malkameramerke = values.Malkameramerke ?? null;
        this.__malkameramerke = values.Malkameramerke ?? null;
        Object.defineProperty(this, 'Malkameramerke', {
            get(): string | null {
                return this.__malkameramerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Malkameramerke', this.__malkameramerke, value);
                this.__malkameramerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Malkameramodel = values.Malkameramodel ?? null;
        this.__malkameramodel = values.Malkameramodel ?? null;
        Object.defineProperty(this, 'Malkameramodel', {
            get(): string | null {
                return this.__malkameramodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Malkameramodel', this.__malkameramodel, value);
                this.__malkameramodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Malkameraserienr = values.Malkameraserienr ?? null;
        this.__malkameraserienr = values.Malkameraserienr ?? null;
        Object.defineProperty(this, 'Malkameraserienr', {
            get(): string | null {
                return this.__malkameraserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Malkameraserienr', this.__malkameraserienr, value);
                this.__malkameraserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Policenumber = values.Policenumber ?? null;
        this.__policenumber = values.Policenumber ?? null;
        Object.defineProperty(this, 'Policenumber', {
            get(): string | null {
                return this.__policenumber;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Policenumber', this.__policenumber, value);
                this.__policenumber = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Rennkomentar = values.Rennkomentar ?? null;
        this.__rennkomentar = values.Rennkomentar ?? null;
        Object.defineProperty(this, 'Rennkomentar', {
            get(): string | null {
                return this.__rennkomentar;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Rennkomentar', this.__rennkomentar, value);
                this.__rennkomentar = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Snowcondition = values.Snowcondition ?? null;
        this.__snowcondition = values.Snowcondition ?? null;
        Object.defineProperty(this, 'Snowcondition', {
            get(): string | null {
                return this.__snowcondition;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Snowcondition', this.__snowcondition, value);
                this.__snowcondition = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startclocklockhomologisering = values.Startclocklockhomologisering ?? null;
        this.__startclocklockhomologisering = values.Startclocklockhomologisering ?? null;
        Object.defineProperty(this, 'Startclocklockhomologisering', {
            get(): string | null {
                return this.__startclocklockhomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startclocklockhomologisering', this.__startclocklockhomologisering, value);
                this.__startclocklockhomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startclocklockmerke = values.Startclocklockmerke ?? null;
        this.__startclocklockmerke = values.Startclocklockmerke ?? null;
        Object.defineProperty(this, 'Startclocklockmerke', {
            get(): string | null {
                return this.__startclocklockmerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startclocklockmerke', this.__startclocklockmerke, value);
                this.__startclocklockmerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startclocklockmodel = values.Startclocklockmodel ?? null;
        this.__startclocklockmodel = values.Startclocklockmodel ?? null;
        Object.defineProperty(this, 'Startclocklockmodel', {
            get(): string | null {
                return this.__startclocklockmodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startclocklockmodel', this.__startclocklockmodel, value);
                this.__startclocklockmodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startclocklockserienr = values.Startclocklockserienr ?? null;
        this.__startclocklockserienr = values.Startclocklockserienr ?? null;
        Object.defineProperty(this, 'Startclocklockserienr', {
            get(): string | null {
                return this.__startclocklockserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startclocklockserienr', this.__startclocklockserienr, value);
                this.__startclocklockserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startgrindhomologisering = values.Startgrindhomologisering ?? null;
        this.__startgrindhomologisering = values.Startgrindhomologisering ?? null;
        Object.defineProperty(this, 'Startgrindhomologisering', {
            get(): string | null {
                return this.__startgrindhomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startgrindhomologisering', this.__startgrindhomologisering, value);
                this.__startgrindhomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startgrindmerke = values.Startgrindmerke ?? null;
        this.__startgrindmerke = values.Startgrindmerke ?? null;
        Object.defineProperty(this, 'Startgrindmerke', {
            get(): string | null {
                return this.__startgrindmerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startgrindmerke', this.__startgrindmerke, value);
                this.__startgrindmerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startgrindmodel = values.Startgrindmodel ?? null;
        this.__startgrindmodel = values.Startgrindmodel ?? null;
        Object.defineProperty(this, 'Startgrindmodel', {
            get(): string | null {
                return this.__startgrindmodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startgrindmodel', this.__startgrindmodel, value);
                this.__startgrindmodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startgrindserienr = values.Startgrindserienr ?? null;
        this.__startgrindserienr = values.Startgrindserienr ?? null;
        Object.defineProperty(this, 'Startgrindserienr', {
            get(): string | null {
                return this.__startgrindserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startgrindserienr', this.__startgrindserienr, value);
                this.__startgrindserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startgrindtype = values.Startgrindtype ?? null;
        this.__startgrindtype = values.Startgrindtype ?? null;
        Object.defineProperty(this, 'Startgrindtype', {
            get(): number | null {
                return this.__startgrindtype;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Startgrindtype', this.__startgrindtype, value);
                this.__startgrindtype = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startpistolhomologisering = values.Startpistolhomologisering ?? null;
        this.__startpistolhomologisering = values.Startpistolhomologisering ?? null;
        Object.defineProperty(this, 'Startpistolhomologisering', {
            get(): string | null {
                return this.__startpistolhomologisering;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startpistolhomologisering', this.__startpistolhomologisering, value);
                this.__startpistolhomologisering = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startpistolmerke = values.Startpistolmerke ?? null;
        this.__startpistolmerke = values.Startpistolmerke ?? null;
        Object.defineProperty(this, 'Startpistolmerke', {
            get(): string | null {
                return this.__startpistolmerke;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startpistolmerke', this.__startpistolmerke, value);
                this.__startpistolmerke = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startpistolmodel = values.Startpistolmodel ?? null;
        this.__startpistolmodel = values.Startpistolmodel ?? null;
        Object.defineProperty(this, 'Startpistolmodel', {
            get(): string | null {
                return this.__startpistolmodel;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startpistolmodel', this.__startpistolmodel, value);
                this.__startpistolmodel = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startpistolserienr = values.Startpistolserienr ?? null;
        this.__startpistolserienr = values.Startpistolserienr ?? null;
        Object.defineProperty(this, 'Startpistolserienr', {
            get(): string | null {
                return this.__startpistolserienr;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Startpistolserienr', this.__startpistolserienr, value);
                this.__startpistolserienr = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Startpistoltype = values.Startpistoltype ?? null;
        this.__startpistoltype = values.Startpistoltype ?? null;
        Object.defineProperty(this, 'Startpistoltype', {
            get(): number | null {
                return this.__startpistoltype;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Startpistoltype', this.__startpistoltype, value);
                this.__startpistoltype = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Synca = values.Synca ?? null;
        this.__synca = values.Synca ?? null;
        Object.defineProperty(this, 'Synca', {
            get(): string | null {
                return this.__synca;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Synca', this.__synca, value);
                this.__synca = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Syncb = values.Syncb ?? null;
        this.__syncb = values.Syncb ?? null;
        Object.defineProperty(this, 'Syncb', {
            get(): string | null {
                return this.__syncb;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Syncb', this.__syncb, value);
                this.__syncb = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Syncbstart = values.Syncbstart ?? null;
        this.__syncbstart = values.Syncbstart ?? null;
        Object.defineProperty(this, 'Syncbstart', {
            get(): string | null {
                return this.__syncbstart;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Syncbstart', this.__syncbstart, value);
                this.__syncbstart = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Synchand = values.Synchand ?? null;
        this.__synchand = values.Synchand ?? null;
        Object.defineProperty(this, 'Synchand', {
            get(): string | null {
                return this.__synchand;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Synchand', this.__synchand, value);
                this.__synchand = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Syncsync = values.Syncsync ?? null;
        this.__syncsync = values.Syncsync ?? null;
        Object.defineProperty(this, 'Syncsync', {
            get(): string | null {
                return this.__syncsync;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Syncsync', this.__syncsync, value);
                this.__syncsync = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tdaddress = values.Tdaddress ?? null;
        this.__tdaddress = values.Tdaddress ?? null;
        Object.defineProperty(this, 'Tdaddress', {
            get(): string | null {
                return this.__tdaddress;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tdaddress', this.__tdaddress, value);
                this.__tdaddress = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tdemail = values.Tdemail ?? null;
        this.__tdemail = values.Tdemail ?? null;
        Object.defineProperty(this, 'Tdemail', {
            get(): string | null {
                return this.__tdemail;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tdemail', this.__tdemail, value);
                this.__tdemail = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tdname = values.Tdname ?? null;
        this.__tdname = values.Tdname ?? null;
        Object.defineProperty(this, 'Tdname', {
            get(): string | null {
                return this.__tdname;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tdname', this.__tdname, value);
                this.__tdname = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tdnation = values.Tdnation ?? null;
        this.__tdnation = values.Tdnation ?? null;
        Object.defineProperty(this, 'Tdnation', {
            get(): string | null {
                return this.__tdnation;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tdnation', this.__tdnation, value);
                this.__tdnation = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tdphone = values.Tdphone ?? null;
        this.__tdphone = values.Tdphone ?? null;
        Object.defineProperty(this, 'Tdphone', {
            get(): string | null {
                return this.__tdphone;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tdphone', this.__tdphone, value);
                this.__tdphone = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Teknisk = values.Teknisk ?? null;
        this.__teknisk = values.Teknisk ?? null;
        Object.defineProperty(this, 'Teknisk', {
            get(): string | null {
                return this.__teknisk;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Teknisk', this.__teknisk, value);
                this.__teknisk = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tempair = values.Tempair ?? null;
        this.__tempair = values.Tempair ?? null;
        Object.defineProperty(this, 'Tempair', {
            get(): string | null {
                return this.__tempair;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tempair', this.__tempair, value);
                this.__tempair = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tempsnow = values.Tempsnow ?? null;
        this.__tempsnow = values.Tempsnow ?? null;
        Object.defineProperty(this, 'Tempsnow', {
            get(): string | null {
                return this.__tempsnow;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Tempsnow', this.__tempsnow, value);
                this.__tempsnow = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Timerclub = values.Timerclub ?? null;
        this.__timerclub = values.Timerclub ?? null;
        Object.defineProperty(this, 'Timerclub', {
            get(): string | null {
                return this.__timerclub;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Timerclub', this.__timerclub, value);
                this.__timerclub = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Timeremail = values.Timeremail ?? null;
        this.__timeremail = values.Timeremail ?? null;
        Object.defineProperty(this, 'Timeremail', {
            get(): string | null {
                return this.__timeremail;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Timeremail', this.__timeremail, value);
                this.__timeremail = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Timerfirstname = values.Timerfirstname ?? null;
        this.__timerfirstname = values.Timerfirstname ?? null;
        Object.defineProperty(this, 'Timerfirstname', {
            get(): string | null {
                return this.__timerfirstname;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Timerfirstname', this.__timerfirstname, value);
                this.__timerfirstname = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Timernation = values.Timernation ?? null;
        this.__timernation = values.Timernation ?? null;
        Object.defineProperty(this, 'Timernation', {
            get(): string | null {
                return this.__timernation;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Timernation', this.__timernation, value);
                this.__timernation = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Timerphone = values.Timerphone ?? null;
        this.__timerphone = values.Timerphone ?? null;
        Object.defineProperty(this, 'Timerphone', {
            get(): string | null {
                return this.__timerphone;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Timerphone', this.__timerphone, value);
                this.__timerphone = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Timersurname = values.Timersurname ?? null;
        this.__timersurname = values.Timersurname ?? null;
        Object.defineProperty(this, 'Timersurname', {
            get(): string | null {
                return this.__timersurname;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Timersurname', this.__timersurname, value);
                this.__timersurname = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Weather = values.Weather ?? null;
        this.__weather = values.Weather ?? null;
        Object.defineProperty(this, 'Weather', {
            get(): string | null {
                return this.__weather;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Weather', this.__weather, value);
                this.__weather = value;
            },
            enumerable: true,
            configurable: true,
        });
    }

    public _setNotifyParentOfModificationCallback(callback: () => void) {
        this.__entityStateHandler.setNotifyParentOfModificationCallback(callback);
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Clockahomologisering": ${JSON.stringify(this.Clockahomologisering)}` +
            ',' +
            `"Clockamerke": ${JSON.stringify(this.Clockamerke)}` +
            ',' +
            `"Clockamodel": ${JSON.stringify(this.Clockamodel)}` +
            ',' +
            `"Clockaserienr": ${JSON.stringify(this.Clockaserienr)}` +
            ',' +
            `"Clockbhomologisering": ${JSON.stringify(this.Clockbhomologisering)}` +
            ',' +
            `"Clockbmerke": ${JSON.stringify(this.Clockbmerke)}` +
            ',' +
            `"Clockbmodel": ${JSON.stringify(this.Clockbmodel)}` +
            ',' +
            `"Clockbserienr": ${JSON.stringify(this.Clockbserienr)}` +
            ',' +
            `"Clockmanualmerke": ${JSON.stringify(this.Clockmanualmerke)}` +
            ',' +
            `"Clockmanualmodel": ${JSON.stringify(this.Clockmanualmodel)}` +
            ',' +
            `"Clockmanualserienr": ${JSON.stringify(this.Clockmanualserienr)}` +
            ',' +
            `"Doctor": ${JSON.stringify(this.Doctor)}` +
            ',' +
            `"EntityState": ${unref(this.__selfEntityState) == 'Unchanged' ? 0 : unref(this.__selfEntityState) == 'Deleted' ? 1 : unref(this.__selfEntityState) == 'Modified' ? 2 : unref(this.__selfEntityState) == 'Added' ? 3 : 0}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"Fotocelleahomologisering": ${JSON.stringify(this.Fotocelleahomologisering)}` +
            ',' +
            `"Fotocelleamerke": ${JSON.stringify(this.Fotocelleamerke)}` +
            ',' +
            `"Fotocelleamodel": ${JSON.stringify(this.Fotocelleamodel)}` +
            ',' +
            `"Fotocelleaserienr": ${JSON.stringify(this.Fotocelleaserienr)}` +
            ',' +
            `"Fotocellebhomologisering": ${JSON.stringify(this.Fotocellebhomologisering)}` +
            ',' +
            `"Fotocellebmerke": ${JSON.stringify(this.Fotocellebmerke)}` +
            ',' +
            `"Fotocellebmodel": ${JSON.stringify(this.Fotocellebmodel)}` +
            ',' +
            `"Fotocellebserienr": ${JSON.stringify(this.Fotocellebserienr)}` +
            ',' +
            `"Insurance": ${JSON.stringify(this.Insurance)}` +
            ',' +
            `"Jurycoc": ${JSON.stringify(this.Jurycoc)}` +
            ',' +
            `"Juryjudge2": ${JSON.stringify(this.Juryjudge2)}` +
            ',' +
            `"Juryjudge3": ${JSON.stringify(this.Juryjudge3)}` +
            ',' +
            `"Jurynationaltd": ${JSON.stringify(this.Jurynationaltd)}` +
            ',' +
            `"Juryracedir": ${JSON.stringify(this.Juryracedir)}` +
            ',' +
            `"Jurytdass": ${JSON.stringify(this.Jurytdass)}` +
            ',' +
            `"Lagledermote": ${JSON.stringify(this.Lagledermote)}` +
            ',' +
            `"Loypesjef": ${JSON.stringify(this.Loypesjef)}` +
            ',' +
            `"Malkamerahomologisering": ${JSON.stringify(this.Malkamerahomologisering)}` +
            ',' +
            `"Malkameramerke": ${JSON.stringify(this.Malkameramerke)}` +
            ',' +
            `"Malkameramodel": ${JSON.stringify(this.Malkameramodel)}` +
            ',' +
            `"Malkameraserienr": ${JSON.stringify(this.Malkameraserienr)}` +
            ',' +
            `"Policenumber": ${JSON.stringify(this.Policenumber)}` +
            ',' +
            `"Rennkomentar": ${JSON.stringify(this.Rennkomentar)}` +
            ',' +
            `"Snowcondition": ${JSON.stringify(this.Snowcondition)}` +
            ',' +
            `"Startclocklockhomologisering": ${JSON.stringify(this.Startclocklockhomologisering)}` +
            ',' +
            `"Startclocklockmerke": ${JSON.stringify(this.Startclocklockmerke)}` +
            ',' +
            `"Startclocklockmodel": ${JSON.stringify(this.Startclocklockmodel)}` +
            ',' +
            `"Startclocklockserienr": ${JSON.stringify(this.Startclocklockserienr)}` +
            ',' +
            `"Startgrindhomologisering": ${JSON.stringify(this.Startgrindhomologisering)}` +
            ',' +
            `"Startgrindmerke": ${JSON.stringify(this.Startgrindmerke)}` +
            ',' +
            `"Startgrindmodel": ${JSON.stringify(this.Startgrindmodel)}` +
            ',' +
            `"Startgrindserienr": ${JSON.stringify(this.Startgrindserienr)}` +
            ',' +
            `"Startgrindtype": ${JSON.stringify(this.Startgrindtype)}` +
            ',' +
            `"Startpistolhomologisering": ${JSON.stringify(this.Startpistolhomologisering)}` +
            ',' +
            `"Startpistolmerke": ${JSON.stringify(this.Startpistolmerke)}` +
            ',' +
            `"Startpistolmodel": ${JSON.stringify(this.Startpistolmodel)}` +
            ',' +
            `"Startpistolserienr": ${JSON.stringify(this.Startpistolserienr)}` +
            ',' +
            `"Startpistoltype": ${JSON.stringify(this.Startpistoltype)}` +
            ',' +
            `"Synca": ${JSON.stringify(this.Synca)}` +
            ',' +
            `"Syncb": ${JSON.stringify(this.Syncb)}` +
            ',' +
            `"Syncbstart": ${JSON.stringify(this.Syncbstart)}` +
            ',' +
            `"Synchand": ${JSON.stringify(this.Synchand)}` +
            ',' +
            `"Syncsync": ${JSON.stringify(this.Syncsync)}` +
            ',' +
            `"Tdaddress": ${JSON.stringify(this.Tdaddress)}` +
            ',' +
            `"Tdemail": ${JSON.stringify(this.Tdemail)}` +
            ',' +
            `"Tdname": ${JSON.stringify(this.Tdname)}` +
            ',' +
            `"Tdnation": ${JSON.stringify(this.Tdnation)}` +
            ',' +
            `"Tdphone": ${JSON.stringify(this.Tdphone)}` +
            ',' +
            `"Teknisk": ${JSON.stringify(this.Teknisk)}` +
            ',' +
            `"Tempair": ${JSON.stringify(this.Tempair)}` +
            ',' +
            `"Tempsnow": ${JSON.stringify(this.Tempsnow)}` +
            ',' +
            `"Timerclub": ${JSON.stringify(this.Timerclub)}` +
            ',' +
            `"Timeremail": ${JSON.stringify(this.Timeremail)}` +
            ',' +
            `"Timerfirstname": ${JSON.stringify(this.Timerfirstname)}` +
            ',' +
            `"Timernation": ${JSON.stringify(this.Timernation)}` +
            ',' +
            `"Timerphone": ${JSON.stringify(this.Timerphone)}` +
            ',' +
            `"Timersurname": ${JSON.stringify(this.Timersurname)}` +
            ',' +
            `"Weather": ${JSON.stringify(this.Weather)}` +
            ',' +
            `"ChangedColumns": ${unref(this.__selfEntityState) !== 'Modified' ? 'null' : JSON.stringify(this.__entityStateHandler.getChangedPropertiesArray())}` +
            '}'
        );
    }

    /**
     * Sets the entity state to Deleted
     */
    public Delete() {
        if (this.__selfEntityState === 'Added') {
            throw new Error('Cannot delete an object that is in Added state. It has not been saved yet.');
        }
        this.__selfEntityState = 'Deleted';
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Undeletes the object by setting resetting the EntityState
     *
     * If the object has modifications, the new state will be 'Modified', otherwise 'Unchanged'
     */
    public DeleteUndo() {
        this.__selfEntityState = 'Unchanged';
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Sets the entity state to Added
     *
     * Also sets the ID to the supplied ID. If no id parameter supplied, the previous id is kept
     *
     * Note: This does not do anything with the children, so use with caution
     *
     * The use case of this is to make copies of existing objects as new objects without having to fill every field.
     */
    public SetEntityStateAsAddedAndResetId(id?: number) {
        if (this.EntityState !== 'Unchanged') {
            throw new Error('Changing a modified object to Added is not supported.');
        }
        this.__selfEntityState = 'Added';
        if (id !== undefined) {
            this.__id = id;
        }
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Creates an instance of FISDataEvent from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Clockahomologisering?: string | null;
        Clockamerke?: string | null;
        Clockamodel?: string | null;
        Clockaserienr?: string | null;
        Clockbhomologisering?: string | null;
        Clockbmerke?: string | null;
        Clockbmodel?: string | null;
        Clockbserienr?: string | null;
        Clockmanualmerke?: string | null;
        Clockmanualmodel?: string | null;
        Clockmanualserienr?: string | null;
        Doctor?: string | null;
        EventID?: number;
        Fotocelleahomologisering?: string | null;
        Fotocelleamerke?: string | null;
        Fotocelleamodel?: string | null;
        Fotocelleaserienr?: string | null;
        Fotocellebhomologisering?: string | null;
        Fotocellebmerke?: string | null;
        Fotocellebmodel?: string | null;
        Fotocellebserienr?: string | null;
        Insurance?: string | null;
        Jurycoc?: string | null;
        Juryjudge2?: string | null;
        Juryjudge3?: string | null;
        Jurynationaltd?: string | null;
        Juryracedir?: string | null;
        Jurytdass?: string | null;
        Lagledermote?: string | null;
        Loypesjef?: string | null;
        Malkamerahomologisering?: string | null;
        Malkameramerke?: string | null;
        Malkameramodel?: string | null;
        Malkameraserienr?: string | null;
        Policenumber?: string | null;
        Rennkomentar?: string | null;
        Snowcondition?: string | null;
        Startclocklockhomologisering?: string | null;
        Startclocklockmerke?: string | null;
        Startclocklockmodel?: string | null;
        Startclocklockserienr?: string | null;
        Startgrindhomologisering?: string | null;
        Startgrindmerke?: string | null;
        Startgrindmodel?: string | null;
        Startgrindserienr?: string | null;
        Startgrindtype?: number | null;
        Startpistolhomologisering?: string | null;
        Startpistolmerke?: string | null;
        Startpistolmodel?: string | null;
        Startpistolserienr?: string | null;
        Startpistoltype?: number | null;
        Synca?: string | null;
        Syncb?: string | null;
        Syncbstart?: string | null;
        Synchand?: string | null;
        Syncsync?: string | null;
        Tdaddress?: string | null;
        Tdemail?: string | null;
        Tdname?: string | null;
        Tdnation?: string | null;
        Tdphone?: string | null;
        Teknisk?: string | null;
        Tempair?: string | null;
        Tempsnow?: string | null;
        Timerclub?: string | null;
        Timeremail?: string | null;
        Timerfirstname?: string | null;
        Timernation?: string | null;
        Timerphone?: string | null;
        Timersurname?: string | null;
        Weather?: string | null;
        EntityState?: 'Added' | 'Unchanged';
    }): FISDataEvent {
        return new FISDataEvent(values);
    }

    public static _FromServerJson(json: any): FISDataEvent {
        return new FISDataEvent({
            ID: json.ID,
            Clockahomologisering: json.Clockahomologisering ?? '',
            Clockamerke: json.Clockamerke ?? '',
            Clockamodel: json.Clockamodel ?? '',
            Clockaserienr: json.Clockaserienr ?? '',
            Clockbhomologisering: json.Clockbhomologisering ?? '',
            Clockbmerke: json.Clockbmerke ?? '',
            Clockbmodel: json.Clockbmodel ?? '',
            Clockbserienr: json.Clockbserienr ?? '',
            Clockmanualmerke: json.Clockmanualmerke ?? '',
            Clockmanualmodel: json.Clockmanualmodel ?? '',
            Clockmanualserienr: json.Clockmanualserienr ?? '',
            Doctor: json.Doctor ?? '',
            EventID: json.EventID,
            Fotocelleahomologisering: json.Fotocelleahomologisering ?? '',
            Fotocelleamerke: json.Fotocelleamerke ?? '',
            Fotocelleamodel: json.Fotocelleamodel ?? '',
            Fotocelleaserienr: json.Fotocelleaserienr ?? '',
            Fotocellebhomologisering: json.Fotocellebhomologisering ?? '',
            Fotocellebmerke: json.Fotocellebmerke ?? '',
            Fotocellebmodel: json.Fotocellebmodel ?? '',
            Fotocellebserienr: json.Fotocellebserienr ?? '',
            Insurance: json.Insurance ?? '',
            Jurycoc: json.Jurycoc ?? '',
            Juryjudge2: json.Juryjudge2 ?? '',
            Juryjudge3: json.Juryjudge3 ?? '',
            Jurynationaltd: json.Jurynationaltd ?? '',
            Juryracedir: json.Juryracedir ?? '',
            Jurytdass: json.Jurytdass ?? '',
            Lagledermote: json.Lagledermote ?? '',
            Loypesjef: json.Loypesjef ?? '',
            Malkamerahomologisering: json.Malkamerahomologisering ?? '',
            Malkameramerke: json.Malkameramerke ?? '',
            Malkameramodel: json.Malkameramodel ?? '',
            Malkameraserienr: json.Malkameraserienr ?? '',
            Policenumber: json.Policenumber ?? '',
            Rennkomentar: json.Rennkomentar ?? '',
            Snowcondition: json.Snowcondition ?? '',
            Startclocklockhomologisering: json.Startclocklockhomologisering ?? '',
            Startclocklockmerke: json.Startclocklockmerke ?? '',
            Startclocklockmodel: json.Startclocklockmodel ?? '',
            Startclocklockserienr: json.Startclocklockserienr ?? '',
            Startgrindhomologisering: json.Startgrindhomologisering ?? '',
            Startgrindmerke: json.Startgrindmerke ?? '',
            Startgrindmodel: json.Startgrindmodel ?? '',
            Startgrindserienr: json.Startgrindserienr ?? '',
            Startgrindtype: json.Startgrindtype ?? null,
            Startpistolhomologisering: json.Startpistolhomologisering ?? '',
            Startpistolmerke: json.Startpistolmerke ?? '',
            Startpistolmodel: json.Startpistolmodel ?? '',
            Startpistolserienr: json.Startpistolserienr ?? '',
            Startpistoltype: json.Startpistoltype ?? null,
            Synca: json.Synca ?? '',
            Syncb: json.Syncb ?? '',
            Syncbstart: json.Syncbstart ?? '',
            Synchand: json.Synchand ?? '',
            Syncsync: json.Syncsync ?? '',
            Tdaddress: json.Tdaddress ?? '',
            Tdemail: json.Tdemail ?? '',
            Tdname: json.Tdname ?? '',
            Tdnation: json.Tdnation ?? '',
            Tdphone: json.Tdphone ?? '',
            Teknisk: json.Teknisk ?? '',
            Tempair: json.Tempair ?? '',
            Tempsnow: json.Tempsnow ?? '',
            Timerclub: json.Timerclub ?? '',
            Timeremail: json.Timeremail ?? '',
            Timerfirstname: json.Timerfirstname ?? '',
            Timernation: json.Timernation ?? '',
            Timerphone: json.Timerphone ?? '',
            Timersurname: json.Timersurname ?? '',
            Weather: json.Weather ?? '',
            EntityState: 'Unchanged',
        });
    }

    /**
     * Creates an instance of FISDataEvent from another instance of FISDataEvent.
     * @param other The FISDataEvent you want to clone
     * @returns A cloned FISDataEvent
     */
    public static FromOther(other: FISDataEvent): FISDataEvent {
        if (other.EntityState !== 'Unchanged') {
            throw new Error('Cloning an object with EntityState other than Unchanged is not supported');
        }
        return FISDataEvent._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return FISDataEvent.FromOther(this);
    }

    /**
     * IsPropertyChanged.
     */
    public IsPropertyChanged(
        ...props: (
            | 'ID'
            | 'Clockahomologisering'
            | 'Clockamerke'
            | 'Clockamodel'
            | 'Clockaserienr'
            | 'Clockbhomologisering'
            | 'Clockbmerke'
            | 'Clockbmodel'
            | 'Clockbserienr'
            | 'Clockmanualmerke'
            | 'Clockmanualmodel'
            | 'Clockmanualserienr'
            | 'Doctor'
            | 'EventID'
            | 'Fotocelleahomologisering'
            | 'Fotocelleamerke'
            | 'Fotocelleamodel'
            | 'Fotocelleaserienr'
            | 'Fotocellebhomologisering'
            | 'Fotocellebmerke'
            | 'Fotocellebmodel'
            | 'Fotocellebserienr'
            | 'Insurance'
            | 'Jurycoc'
            | 'Juryjudge2'
            | 'Juryjudge3'
            | 'Jurynationaltd'
            | 'Juryracedir'
            | 'Jurytdass'
            | 'Lagledermote'
            | 'Loypesjef'
            | 'Malkamerahomologisering'
            | 'Malkameramerke'
            | 'Malkameramodel'
            | 'Malkameraserienr'
            | 'Policenumber'
            | 'Rennkomentar'
            | 'Snowcondition'
            | 'Startclocklockhomologisering'
            | 'Startclocklockmerke'
            | 'Startclocklockmodel'
            | 'Startclocklockserienr'
            | 'Startgrindhomologisering'
            | 'Startgrindmerke'
            | 'Startgrindmodel'
            | 'Startgrindserienr'
            | 'Startgrindtype'
            | 'Startpistolhomologisering'
            | 'Startpistolmerke'
            | 'Startpistolmodel'
            | 'Startpistolserienr'
            | 'Startpistoltype'
            | 'Synca'
            | 'Syncb'
            | 'Syncbstart'
            | 'Synchand'
            | 'Syncsync'
            | 'Tdaddress'
            | 'Tdemail'
            | 'Tdname'
            | 'Tdnation'
            | 'Tdphone'
            | 'Teknisk'
            | 'Tempair'
            | 'Tempsnow'
            | 'Timerclub'
            | 'Timeremail'
            | 'Timerfirstname'
            | 'Timernation'
            | 'Timerphone'
            | 'Timersurname'
            | 'Weather'
        )[]
    ) {
        return this.__entityStateHandler.isPropertyChanged(...props);
    }
    static NAME_OF_CLASS = 'FISDataEvent';
}
